/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 03 2024
 **/

import styled from "@emotion/styled";

import { Column, Row, Typography } from "@/frameworks/designStuff/components";

export const NoticeWrapper = styled(Column)`
	width: 540px;
	height: 210px;
	padding: 28px 20px 20px 20px;
	border-radius: 0px 0px 16px 16px;
	background-color: white;
	position: relative;
`;

export const NoticeWrapperGroupJoin = styled(Column)`
	width: 540px;
	height: 180px;
	padding: 28px 20px 20px 20px;
	border-radius: 0px 0px 16px 16px;
	background-color: white;
	position: relative;
`;

export const CancelRequestWrapper = styled(NoticeWrapper)`
	height: auto;
`;

export const ImageBox = styled(Row)`
	position: relative;
	cursor: pointer;
	width: 80px;
	height: 80px;
	border-radius: 12px;
	display: flex;
	background: ${({ bgcolor }: { bgcolor: string }) => bgcolor};
	align-items: center;
	justify-content: center;
`;

export const NameTypo = styled(Typography.p)`
	padding: 8px 4px;
	width: 72px;
	color: ${({ theme }) => theme.colors.neutral_00_100};
	word-break: break-all;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	width: 100%;
	text-align: center;
`;

export const Img = styled.img`
	width: 100%;
	height: 100%;
	border-radius: 12px;
	object-fit: cover;
`;
